export const GET_ALL_GAMES = "GET_ALL_GAMES";
export const DELETE_GAME = "DELETE_GAME";
export const ADD_GAME = "ADD_GAME";
export const EDIT_GAME = "EDIT_GAME";
export const GET_GAME_STATUSES = "GET_GAME_STATUSES";
export const GET_HOST_TEAM_PLAYERS = "GET_HOST_TEAM_PLAYERS"
export const GET_GUEST_TEAM_PLAYERS = "GET_GUEST_TEAM_PLAYERS"
export const CLEAR_GAMES = "CLEAR_GAMES";